// tslint:disable:max-line-length

import React from 'react';

export const OperatorEqual = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M4.46 6.79v-1.6h7.07v1.6zm0 3.19v-1.6h7.07V10z" />
    </svg>
  );
};
